<template>
  <div class="s-setting-container no-border">
    <div class="main-header">
      <div>
        Unit Preferences
        <div class="sub-header">
          These preferences will directly impact the partners NOC and the Pro App.
        </div>
      </div>
      <div v-if="adminRole === 'admin'">
        <SaveCancelSection
          :cancel="resetPartnerConfig"
          :save="updatePartnerConfig"
          :disabled="!changeCheck"
        />
      </div>
    </div>
    <PreferencesSettings
      :temperature="temperature"
      :dateFormat="dateFormat"
      :pressure="pressure"
      :distance="distance"
      :onChange="handleChange"
    />
    <ProcessOverlay
      :show="updating"
      text="Saving"
    />
  </div>
</template>

<script>
import partnerSettingsMixin from '@shared/mixins/partnerSettingsMixin';

import PreferencesSettings from '@shared/components/partnerSettings/unitsPreferences/PreferencesSettings.vue';
import SaveCancelSection from '@shared/components/setting/shared/SaveCancelSection.vue';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

export default {
  name: 'UnitPreferencesSection',
  components: {
    PreferencesSettings,
    SaveCancelSection,
    ProcessOverlay,
  },
  mixins: [partnerSettingsMixin],
  props: {
    corpId: Number,
    partnerSettings: Object,
    update: Function,
  },
  data() {
    const {
      TEMP_UNIT = '°F',
      DATE_FORMAT = 'MM-DD-YYYY',
      DISTANCE_UNIT = 'mi',
      PRESSURE_UNIT = 'inH2O',
    } = this.partnerSettings;
    return {
      temperature: TEMP_UNIT,
      dateFormat: DATE_FORMAT,
      distance: DISTANCE_UNIT,
      pressure: PRESSURE_UNIT,
      updating: false,
    };
  },
  computed: {
    changeCheck() {
      let changes = false;
      const {
        TEMP_UNIT = '°F',
        DATE_FORMAT = 'MM-DD-YYYY',
        DISTANCE_UNIT = 'mi',
        PRESSURE_UNIT = 'inH2O',
      } = this.partnerSettings;
      const {
        temperature,
        dateFormat,
        distance,
        pressure,
      } = this;
      // return TEMP_UNIT !== temperature || DATE_FORMAT !== dateFormat
      //   || DISTANCE_UNIT !== distance || PRESSURE_UNIT !== pressure;
      if (TEMP_UNIT !== temperature || DATE_FORMAT !== dateFormat
        || DISTANCE_UNIT !== distance || PRESSURE_UNIT !== pressure) {
        changes = true;
      }
      if (!changes) {
        this.changePartnerSettingsValue('showWarningOnExit', false);
      } else if (changes && !this.showWarningOnExit && !this.warningTab) {
        this.changePartnerSettingsValue('showWarningOnExit', true);
      }
      return changes;
    },
  },
  methods: {
    handleChange(field, value) {
      this[field] = value;
    },
    resetPartnerConfig() {
      const {
        TEMP_UNIT = '°F',
        DATE_FORMAT = 'MM-DD-YYYY',
        DISTANCE_UNIT = 'mi',
        PRESSURE_UNIT = 'inH2O',
      } = this.partnerSettings;
      this.temperature = TEMP_UNIT;
      this.dateFormat = DATE_FORMAT;
      this.distance = DISTANCE_UNIT;
      this.pressure = PRESSURE_UNIT;
    },
    async updatePartnerConfig() {
      const {
        temperature,
        dateFormat,
        distance,
        pressure,
      } = this;
      this.changePartnerSettingsValue('showWarningOnExit', false);
      this.updating = true;
      await this.update({
        TEMP_UNIT: temperature,
        DATE_FORMAT: dateFormat,
        DISTANCE_UNIT: distance,
        PRESSURE_UNIT: pressure,
      });
      this.updating = false;
    },
  },
};
</script>